// extracted by mini-css-extract-plugin
export default {"error":"styles_error__on21P","root":"styles_root__iO7N+"};